/**
 * Jay 10-25 (ehr#24, ehr#252): sharing a note or a filled form with someone who can't open the
 * client also shares the client with them (View only), so they can read it in the chart. The share
 * pickers say so, where the V38 picker said "You may only share notes after a contact has been
 * shared".
 */
export function clientShareHint(item: 'note' | 'form'): string {
  return `Anyone here who can't open this contact yet gets it shared with them (View only), so they can read the ${item}.`;
}
